import { House } from '@mui/icons-material';
import { FieldControllerTypes, FieldTypes, IFormController } from '../../../components/form_v2/types';
import { Dispatch, SetStateAction } from 'react';
import { acceptedDoc, acceptedImage } from '../../../lib/generalTypes';

export const insertDocumentFields = (
  type_options: any[],
  formatOptions: any[],
  erga: any[]
) => {

  const colorOptions = [
    { key: 'Έγχρωμο', value: 'Έγχρωμο' },
    { key: 'Ασπρόμαυρο', value: 'Ασπρόμαυρο' },
  ];
  const soundOptions = [
    { key: 'ΝΑΙ', value: 'ΝΑΙ' },
    { key: 'ΌΧΙ', value: 'ΌΧΙ' },
  ];
  const insertStep1Form: IFormController[] = [
    {
      control: FieldControllerTypes.input,
      label: 'Μοναδικός Κωδικός Τεκμηρίου',
      name: 'documentsUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aναγνωριστικό Τεκμηρίου',
      name: 'documentIdentifier',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Φορέας που ανήκει το Τεκμηριο',
      name: 'documentsRelationOrganisation',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Συλλογή που ανήκει το Τεκμήριο',
      name: 'documentsRelationCollection',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Τεκμηρίου',
      name: 'documentsTitle',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Τεκμηρίου στα Αγγλικά',
      name: 'documentsEnTitle',
      required: true,
    },
    {
      control: FieldControllerTypes.select,
      label: 'Τύπος Τεκμηρίου',
      name: 'documentsType',
      required: true,
      options: type_options
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Τεκμηρίου',
      name: 'documentsDescription',
      required: true,
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Τεκμηρίου στα Αγγλικά',
      name: 'documentsEnDescription',
      required: true,
    },
    {
      control: FieldControllerTypes.input,
      label: 'Ημερομηνία Δημιουργίας',
      name: 'documentsDateCreation',
    },
    {
      control: FieldControllerTypes.autoselect,
      label: 'Μορφότυπο',
      name: 'documentsFormat',
      required: true,
      customLabel: true,
      options: formatOptions
    },
    {
      control: FieldControllerTypes.input,
      label: 'Διάρκεια',
      name: 'documentsDuration'
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Χρώμα',
      name: 'documentsColor',
      row: true,
      options: colorOptions
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Ηχος',
      name: 'documentsSound',
      row: true,
      options: soundOptions
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τεχνική',
      name: 'documentsTechnical',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Μέγεθος',
      name: 'documentsSize',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Ύψος',
      name: 'documentsHeight',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Πλάτος',
      name: 'documentsWidth',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Frame Rate',
      name: 'documentsFrameRate',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aspect Ratio',
      name: 'documentsAspectRatio',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Copyright',
      name: 'documentsCopyright',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Άδεια Χρήσης',
      name: 'documentsLicence',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Τεκμηρίου',
      name: 'documentsComments',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Τεκμηρίου English',
      name: 'documentsEnComments',
    },
    {
      control: FieldControllerTypes.input,
      label: 'Video URL',
      name: 'documentsVimeoYtTitle',
      placeholder: 'Τίτλος',
    },
    {
      control: FieldControllerTypes.input,
      name: 'documentsVimeoYtUrl',
      placeholder: 'URL',
    },
    {
      control: FieldControllerTypes.file,
      type: FieldTypes.file,
      label: 'Συννημένα Αρχεία Eικόνας',
      name: 'documentsAttachedMediaImages',
      multiple: true,
      nofiles: 10,
      accepts: [...acceptedImage]
    },
    {
      control: FieldControllerTypes.file,
      label: 'Συννημένα Εγγραφα',
      name: 'documentsAttachedMediaFiles',
      multiple: true,
      nofiles: 10,
      accepts: [...acceptedDoc]
    },
  ];
  const insertStep2Form: IFormController[] = [
    {
      control: FieldControllerTypes.autoselect,
      label: 'Τίτλος Έργου',
      name: 'documentsRelationProject',
      required: true,
      customLabel: true,
      options: erga
    }
  ];
  const insertStep1 = {
    label: 'Βασικές Πληροφορίες Τεκμηρίου',
    content: insertStep1Form,
    icon: <House/>,
    name: ''
  };
  const insertStep2 = {
    label: 'Σύνδεση με Έργα',
    content: insertStep2Form,
    icon: <House/>,
    name: ''
  };
  return [
    {...insertStep1},
    {...insertStep2},
  ];
};

export const createDocumentFields = ({
  organisations,
  collections,
  selectedForeas,
  setSelectedForeas
}: {
  organisations: {key: string, value: number}[],
  collections: {key: string, value: number}[],
  selectedForeas: string | undefined,
  setSelectedForeas: Dispatch<SetStateAction<string | undefined>>
}) => {
  const step1Form: IFormController[] | IFormController[][] = [
    [
      {
        control: FieldControllerTypes.select,
        label: 'Επιλέξτε Ανανγωριστικό Φορέα',
        name: 'organisationsIdentifier',
        required: true,
        options: organisations,
        selectedItem: (selectedValue: string) => setSelectedForeas(selectedValue)
      },
      {
        control: FieldControllerTypes.select,
        label: 'Επιλέξτε Συλλογή',
        name: 'collectionsUniqueCode',
        required: true,
        disabled: !selectedForeas,
        options: collections?.length > 0
          ? collections?.filter(
            (x: any) => x?.['collectionsIdentifierUniqueCode'].split('_').slice(0, -1).join('_') == selectedForeas
          )
          : collections
      }
    ],
    [
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.number,
        label: 'Id Τεκμηρίου',
        name: 'documentsId',
        required: true,
        positives_only: true
      },
      {
        control: FieldControllerTypes.input,
        type: FieldTypes.search,
        label: 'Τίτλος Τεκμηρίου',
        name: 'documentsTitle',
        required: true,
      }
    ]
  ];

  const step1 = {
    label: 'Στοιχεία Εκκίνησης Καταχώρισης Τεκμηρίου',
    content: step1Form,
    icon: <House/>
  };

  return [
    {...step1}
  ];
};